import {skipToken} from '@reduxjs/toolkit/query';

import {isNilOrEmpty, isNotNil} from 'ramda-adjunct';

import {
  useGetCheckoutForBusinessCaseQuery,
  useGetLastActiveBuyingBusinessCaseQuery,
} from '@dms/api/sales';

import {getSupplierInvoiceNumberFromCheckout} from '../utils/getSupplierInvoiceNumberFromCheckout';

/**
 * Resolves the supplier invoice number a user has already entered on the vehicle's purchase payment,
 * so a vehicle warehouse receipt can offer it as a default instead of making them retype it.
 *
 * No error is reported on purpose - a vehicle without an active buying business case, or a user
 * without the permission to read it, must still get a working dialog with an empty field.
 */
export function useCheckoutSupplierInvoiceNumber(vehicleId: string) {
  const {data: buyingBusinessCase, isLoading: isBusinessCaseLoading} =
    useGetLastActiveBuyingBusinessCaseQuery({vehicleId}, {skip: isNilOrEmpty(vehicleId)});

  const {data: checkout, isLoading: isCheckoutLoading} = useGetCheckoutForBusinessCaseQuery(
    isNotNil(buyingBusinessCase) ? {businessCaseId: buyingBusinessCase.id} : skipToken
  );

  return {
    supplierInvoiceNumber: getSupplierInvoiceNumberFromCheckout(checkout),
    isLoading: isBusinessCaseLoading || isCheckoutLoading,
  };
}
